import fetchSearchCatNavBanners from "@faire/web-api/api/v2/products/search/banners/post";
import { ISearchCatNavBannersResponse } from "@faire/web-api/indigofair/data/ISearchCatNavBannersResponse";
import { cachingApi } from "@faire/web/common/cachingApi";
import { singletonGetter } from "@faire/web/common/singletons/getter";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";

import { isLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";

/**
 * @deprecated prefer to use `useCachedBannerResponseStore` or `withStores` instead
 */
export class CachedBannerResponseStore {
  static get = singletonGetter(CachedBannerResponseStore);

  cachedRequest = isLoggedInRetailer()
    ? () => ISearchCatNavBannersResponse.build()
    : cachingApi(fetchSearchCatNavBanners);
}
export const useCachedBannerResponseStore = createStoreHook(
  CachedBannerResponseStore
);
